import React from 'react'
import styled from 'styled-components'
import Landing from "../../asset/desktop/landing.png"
import Title from "../../components/common/Title";
import Linkedin from "../../asset/desktop/linkedin.svg"


import Gugu from "../../asset/desktop/people/gugu.jpg"
import alabi from "../../asset/desktop/people/alabi.png"
import ayeola from "../../asset/desktop/people/Ayeola.jpg"
import Ayomide from "../../asset/desktop/people/Ayomide.jpg"
import bamidelee from "../../asset/desktop/people/bamidelee.jpg"
import benonuoha from "../../asset/desktop/people/benonuoha.jpeg"
import chris from "../../asset/desktop/people/chris.jpg"
import Idris from "../../asset/desktop/people/Idris.jpg"
import Marvel from "../../asset/desktop/people/Marvel.jpg"
import Maureen from "../../asset/desktop/people/Maureen.jpeg"
// import Micheal from "../../asset/desktop/people/Micheal.jpg"
import mpadi from "../../asset/desktop/people/mpadi.jpg"
import Oluwatobiloba from "../../asset/desktop/people/Oluwatobiloba.jpg"
import Rasheedat from "../../asset/desktop/people/Rasheedat.jpg"
import Ruth from "../../asset/desktop/people/Ruth.jpg"
import Victor from "../../asset/desktop/people/Victor.jpg"

const BlueOverlay = styled.div`
  background: url(${Landing});
  height: 452px;
  display: flex;
  align-items: center;
  position: relative;
  background-size: cover;
  background-repeat: no-repeat;

  .overlay{
    background-color: rgba(24, 33, 116, 0.89);
    z-index: 2;
  }
  `;

const Holder = styled.div`
  img.user{
    width: 100%;
    height: 350px;
    object-fit: cover;
  }
  h1{
    font-size: 1.5rem ;
    font-weight: bold;
    color: #333333;
    margin: .5rem 0;
  }
`;

const People = () => {

  const allDetails = [
    {
      img: Gugu,
      name: "Gugulethu Nyathi",
      title: "Founder",
      linkedin: "https://www.linkedin.com/in/gugu-newman-nyathi-11ab17a7/",
    },
    {
      img: mpadi,
      name: "Mpadi Makgalo",
      title: "Public Health",
      linkedin: "",
    },
    {
      img: benonuoha,
      name: "Ben Onuoha",
      title: "Blockchain Strategy",
      linkedin: "https://www.linkedin.com/in/benonuoha/",
    },
    {
      img: chris,
      name: "Chris Maree",
      title: "Tech Advisory",
      linkedin: "",
    },
    {
      img: bamidelee,
      name: "Alegbe Bamidele",
      title: "Tech Advisory",
      linkedin: "https://www.linkedin.com/in/bamidelealegbe/",
    },
    {
      img: Maureen,
      name: "Maureen Omeoga",
      title: "Human Relations",
      linkedin: "https://linkedin.com/in/eziaku-omeoga-acipm-a52127100",
    },
    // {
    //   img: Micheal,
    //   name: "Micheal Oladimeji",
    //   title: "Software Tester",
    //   linkedin: "",
    // },
    {
      img: alabi,
      name: "Alabi Olawale",
      title: "Software Tester",
      linkedin: "https://www.linkedIn.com/in/alabi-ibrahim-7437a518a",
    },
    {
      img: Ruth,
      name: "Ruth Idaname",
      title: "UI/UX Designer",
      linkedin: "https://www.linkedin.com/in/ruth-douglas-485751201",
    },
    {
      img: Rasheedat,
      name: "Rasheedat Usman",
      title: "UI/UX Designer",
      linkedin: "https://www.linkedin.com/in/rasheedat-usman-158736174/",
    },
    {
      img: Ayomide,
      name: "Ayomide Peter",
      title: "Software Developer",
      linkedin: "https://www.linkedin.com/in/ayomide-osunsami-6440021b0/",
    },
    {
      img: ayeola,
      name: "Ayeola Olatunde",
      title: "Software Developer",
      linkedin: "https://www.linkedin.com/in/ayeolakenny/",
    },
    {
      img: Marvel,
      name: "Marvel Afolabi",
      title: "Software Developer",
      linkedin: "https://www.linkedin.com/in/marvelous-afolabi-22a290183",
    },
    {
      img: Victor,
      name: "Oluwasegun Victor",
      title: "Software Developer",
      linkedin: "https://www.linkedin.com/in/oluwasegun-alayemi/",
    },
    {
      img: Idris,
      name: "Idris Ifeoluwa",
      title: "Software Developer",
      linkedin: "https://www.linkedin.com/in/bobby-dev",
    },
  ]
  return (
    <section className = 'mt-6'>
      <BlueOverlay >
        <div className="overlay absolute top-0 right-0 w-full h-full"></div>
        <div className="container mx-auto px-5 z-10">
          <Title text='People' bgc='#000B6A' textColor="white" />
        </div>
      </BlueOverlay>


      <section className="-mt-32 mb-16 px-5 lg:px-32 z-30 relative grid md:grid-cols-2 lg:grid-cols-3 lg:gap-y-12 gap-10 container mx-auto">
        {
          allDetails.map((person, i) => (
            <Holder className="w-full mx-auto" key = {i}>
              <img src={person.img} alt="" className="user rounded-lg" />
              <h1 >{person.name}</h1>
              <div className="flex items-center justify-between">
                <p className="font-medium text-lg">{person.title}</p>
                <a href={person.linkedin} target="_blank" className="w-8">
                  <img src={Linkedin} alt="" className="" />
                </a>
              </div>
            </Holder>

          ))
        }

      </section>

    </section>
  )
}

export default People
